import { useMutation } from "@tanstack/react-query"
import { apiClient } from "@/api/client"
import type {
  Step1DetectOnPeriodsRequest,
  Step1DetectOnPeriodsResponse,
  Step1FallbackDetectOnPeriodRequest,
  Step2ValidateCycleRequest,
  Step2ValidateCycleResponse,
  Step3ExtractFeaturesRequest,
  Step3ExtractFeaturesResponse,
  Step4PredictRequest,
  Step4PredictResponse,
  ChargeDetectionFeedbackRequest,
  ChargeDetectionFeedbackResponse,
} from "./types"

async function post<T>(url: string, data: unknown): Promise<T> {
  try {
    const response = await apiClient.post<T>(url, data)
    return response.data
  } catch (error: any) {
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error)
    }
    throw error
  }
}

export const useChargeDetection = () => {
  const step1DetectOnPeriodsMutation = useMutation({
    mutationFn: (request: Step1DetectOnPeriodsRequest) =>
      post<Step1DetectOnPeriodsResponse>('charge-detection/step-1-detect-on-periods/', request),
  })

  const step1FallbackDetectOnPeriodMutation = useMutation({
    mutationFn: (request: Step1FallbackDetectOnPeriodRequest) =>
      post<Step1DetectOnPeriodsResponse>('charge-detection/step-1-fallback-detect-on-period/', request),
  })

  const step2ValidateCycleMutation = useMutation({
    mutationFn: (request: Step2ValidateCycleRequest) =>
      post<Step2ValidateCycleResponse>('charge-detection/step-2-validate-cycle/', request),
  })

  const step3ExtractFeaturesMutation = useMutation({
    mutationFn: (request: Step3ExtractFeaturesRequest) =>
      post<Step3ExtractFeaturesResponse>('charge-detection/step-3-extract-features/', request),
  })

  const step4PredictMutation = useMutation({
    mutationFn: (request: Step4PredictRequest) =>
      post<Step4PredictResponse>('charge-detection/step-4-predict/', request),
  })

  const submitFeedbackMutation = useMutation({
    mutationFn: (request: ChargeDetectionFeedbackRequest) =>
      post<ChargeDetectionFeedbackResponse>('charge-detection/feedback/', request),
  })

  return {
    step1DetectOnPeriods: step1DetectOnPeriodsMutation,
    step1FallbackDetectOnPeriod: step1FallbackDetectOnPeriodMutation,
    step2ValidateCycle: step2ValidateCycleMutation,
    step3ExtractFeatures: step3ExtractFeaturesMutation,
    step4Predict: step4PredictMutation,
    submitFeedback: submitFeedbackMutation,
  }
}